import { memo } from "react";

import Box from "@mui/material/Box";

import { Device } from "../../../../../../API";
import LiveViewSidebarPlayer from "./LiveViewSidebarPlayer";
import LiveViewZonesList from "./LiveViewZonesList";
import { useHasNotRoleAccess } from "../../../../../../common/hooks/useCheckRoleAccess";

type LiveViewTabProps = {
  device: Device;
};

const LiveViewTab = ({ device }: LiveViewTabProps): JSX.Element => {
  const isNotOperatorRole = useHasNotRoleAccess("readonly");

  return (
    <Box>
      <Box
        sx={{
          marginTop: 2,
        }}
      >
        <LiveViewSidebarPlayer device={device} showControls />
      </Box>

      {device.deviceData.hasPanTilt && isNotOperatorRole && (
        <LiveViewZonesList device={device} />
      )}
    </Box>
  );
};

export default memo(LiveViewTab);
